export default "__VITE_ASSET__grjn_r6d__"